import { View } from 'react-native'
import { useViewportLayout } from 'utils/helper-device'
import { AppStyles } from 'styles/App'
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'


const WebContainerView = ({ containerStyle = {}, style = {}, children }) => {
	
	const dimensions = useViewportLayout()
	const appFullWidth = useSelector( state => {
		return state.data[dataConstants.APP_FULL_WIDTH];
	} );
	const fillViewport = appFullWidth || !dimensions.isSmallDevice;
	
	// width/height dimensions are set here to ensure they adapt to the screen size!
	const webContainerMargin = fillViewport ? 0 : 20;
	const webContainerHeight = dimensions.height - ( webContainerMargin * 2 );
	
	const webStyles = [
		AppStyles.webContainer,
		fillViewport ? AppStyles.webContainerFullWidth : AppStyles.webContainerMaxWidth,
		{ height: webContainerHeight, margin: webContainerMargin },
		fillViewport ? { borderWidth: 0, borderRadius: 0 } : null,
		style
	]
	
	return (
		<View
			style={[ AppStyles.webBackground, containerStyle ]}>
			
			<View
				style={ webStyles }>
				
				{ children }
			</View>
		</View>
	)
}

export default WebContainerView
